import { motion } from "framer-motion";
import { Home, TrendingUp, Eye, Layers } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const POINTS = [
  { title: "FAMILY OWNED", text: "Local, independent scrap-metal recycling in Ashley, Ohio.", Icon: Home },
  { title: "TOP-DOLLAR PRICING", text: "Competitive purchasing based on current scrap markets.", Icon: TrendingUp },
  { title: "VISIBLE SCALES", text: "Customers can see their material being weighed.", Icon: Eye },
  { title: "FERROUS + NON-FERROUS", text: "From everyday scrap to higher-value metals.", Icon: Layers },
];

export const WhyScrapmans = () => (
  <section id="why-scrapmans" className="bg-zinc-950 py-20 sm:py-28" data-testid="why-scrapmans-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag number="05" label="The Yard" dark />
        <h2 className="font-heading text-4xl sm:text-5xl text-white tracking-tight">
          WHY <span className="text-red-500">SCRAPMAN'S</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800">
        {POINTS.map((p, i) => (
          <motion.div
            key={p.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="bg-zinc-950 p-8 group hover:bg-zinc-900 transition-colors"
            data-testid={`why-point-${i}`}
          >
            <p.Icon className="h-7 w-7 text-red-500 mb-5" />
            <h3 className="font-heading text-xl text-white tracking-wide">{p.title}</h3>
            <p className="mt-3 text-zinc-400 text-sm leading-relaxed">{p.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
